'use client'

import type { MyUser } from '@/api/v2/types'

import useAuth from '@/hooks/use-auth'
import useSocketEvent from '@/hooks/use-socket-event'
import queryClient from '@/services/queryClient'
import { socket } from '@/services/socket'

import Currency from '@/components/currency'
import CoinsIcon from '@/components/icons/coins'
import { usePathname } from '@/navigation'

export default function HeaderUserBalance() {
  const { user } = useAuth()
  const pathname = usePathname()

  const isProviderGame = pathname.includes('games/') && pathname.includes(':')

  useSocketEvent(socket, 'depositEmit', (data) => {
    const newBalance = data.amountUsd

    queryClient.setQueryData<MyUser>(['user'], (oldData) => {
      if (user && data?.id === user?.id) {
        return {
          ...oldData,
          balanceUsd: oldData!.balanceUsd + newBalance,
        } as MyUser
      }

      return oldData
    })
  })

  return (
    <Currency
      amount={user?.balanceUsd ?? 0}
      symbol={<CoinsIcon color='#24D861' />}
      alignItems='center'
      gap={2}
      textProps={{
        fontSize: 'sm',
      }}
      isProviderGame={isProviderGame}
    />
  )
}
